import { BoxV2 as Box, Flex, TextInput } from 'portal-commons';
import { FunctionComponent } from 'react';
import { FieldError } from 'react-hook-form';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SampleMessageInputProps {
  removable?: boolean;
  error?: FieldError;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onRemove?: () => void;
  [key: `data-${string}`]: unknown;
}

const SampleMessageInput: FunctionComponent<SampleMessageInputProps> = ({
  removable,
  error,
  value,
  onChange,
  onBlur,
  onRemove,
  ...props
}) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      gap: 'xs',
      width: '100%',
    }}
  >
    <TextInput
      style={{ flex: 1 }}
      multiline
      error={!!error?.message}
      label="Sample Message"
      note={error?.message}
      minRows={3}
      maxRows={3}
      maxLength={1024}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      data-testid={props['data-testid']}
    />
    {removable && (
      <Box sx={{ cursor: 'pointer' }} onClick={onRemove}>
        <FontAwesomeIcon icon={faTrashCan} />
      </Box>
    )}
  </Flex>
);

export default SampleMessageInput;
